import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';

import useIsNativeWebView from '../../../native-bridge/hooks/useIsWebView';
import AccountCardAlbumCustomPrintConfigurator from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/AccountCardAlbumCustomPrintOption/AccountCardAlbumCustomPrintConfigurator';
import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import useStandaloneAlbumCustomPrintConfigurator from './hooks/useStandaloneAlbumCustomPrintConfigurator';
import {
  postNativeAppAlbumCustomPrintConfiguratorDismiss,
  postNativeAppAlbumCustomPrintConfiguratorComplete,
} from '../../../native-bridge/native-apps-interface';
import {
  CUSTOM_PRINT_SUBTYPE,
  CUSTOM_PRINT_TYPE,
} from '../../../../constants/pro-custom-prints';
import getLogger from '../../../../util/logger';

const log = getLogger('StandaloneAlbumCustomPrintConfigurator');

const StandaloneAlbumCustomPrintConfigurator = () => {
  const location = useLocation();
  const { albumCustomPrintId } = useParams();
  const { accountCardId } = qs.parse(location.search);
  const isNativeWebView = useIsNativeWebView();
  const { albumCustomPrint, loading } =
    useStandaloneAlbumCustomPrintConfigurator({ albumCustomPrintId });

  if (!albumCustomPrint || loading) {
    return <FullScreenLoader />;
  }

  const { custom_print: customPrint } = albumCustomPrint;
  const isCollage =
    customPrint.type === CUSTOM_PRINT_TYPE.PRINT_PRODUCT &&
    customPrint.subtype === CUSTOM_PRINT_SUBTYPE.COLLAGE;

  return (
    <AccountCardAlbumCustomPrintConfigurator
      onClose={
        isNativeWebView
          ? () => {
              postNativeAppAlbumCustomPrintConfiguratorDismiss();
            }
          : undefined
      }
      onFinished={({ accountCard }) => {
        log.info('onComplete :: ', {
          accountCard,
          albumCustomPrint,
        });

        if (isNativeWebView) {
          postNativeAppAlbumCustomPrintConfiguratorComplete({
            accountCard,
            albumCustomPrint,
          });
        }
      }}
      isAllPhotos
      albumCustomPrint={albumCustomPrint}
      albumMembershipGroup={{
        is_album: true,
        id: albumCustomPrint.album?.id,
        album: albumCustomPrint.album,
      }}
      defaultAccountCard={accountCardId ? { id: accountCardId } : undefined}
      buttonText={isCollage ? 'Create my Camper Collage' : undefined}
      forceEntitlement={isCollage}
      title={isCollage ? 'Design your collage!' : undefined}
      inlineButton={isCollage}
      altClassName={
        isCollage
          ? 'event-collage-option-account-card-configurator-modal'
          : undefined
      }
    />
  );
};

export default StandaloneAlbumCustomPrintConfigurator;
